import { cn } from '@/lib/utils'
import { NostrUser } from '@nostr/gadgets/metadata'
import Username from '../Username'

export function EmbeddedMention({
  user,
  className
}: {
  user: string | NostrUser
  className?: string
}) {
  return (
    <Username
      user={user}
      className={cn('text-primary font-normal inline', className)}
      withoutSkeleton
    />
  )
}
